import React, { useCallback, useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import FormInput from 'components/FormInput'
import FormInputDatePicker from 'components/FormInputDatePicker'
import { Box } from '@mui/system'
import Label from 'components/Label'
import FormControlRadio from 'components/FormControlRadio'
import FormInputNumber from 'components/FormInputNumber'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import genericService from '../../../../services/generic.service'

export const trabalhoOptions = [
  { label: 'Mercado Formal', value: 'FORMAL' },
  { label: 'Trabalho Infantil', value: 'INFANTIL' },
  { label: 'Trabalho Não Regulamentado', value: 'NAO_REGULAMENTADO' },
  { label: 'Mercado Informal', value: 'INFORMAL' },
]

export const motivosOptions: ItemOption[] = [
  { value: 'DESEMPENHO_ENTREVISTA', label: 'a) Desempenho na entrevista' },
  { value: 'BAIXA_ESCOLARIDADE', label: 'b) Baixa escolaridade' },
  { value: 'DISTANCIA_LOCAL_APRENDIZAGEM', label: 'c) Distância casa- local de aprendizagem' },
  { value: 'TURNO_INCOMPATIVEL', label: 'd) Turno escolar incompatível' },
  { value: 'DESINTERESSE', label: 'e) Desinteresse pelo curso de formação' },
]

export const motivosNaoAdesaoOptions: ItemOption[] = [
  { value: 'FALTAS', label: 'a) Faltas' },
  { value: 'SOBRECARGA', label: 'b) Sobrecarga de atividades' },
  {
    value: 'DIFICULDADE_ACOMPANHAR_CURSO',
    label: 'c) Dificuldade em acompanhar conteúdo do curso de formação',
  },
  { value: 'DESINTERESSE_CURSO', label: 'd) Desinteresse pelo curso de formação' },
  { value: 'ABANDONO_ESCOLAR', label: 'e) Abandono escolar' },
  {
    value: 'OPORUNIDADE_MELHO_REMUNERACAO',
    label: 'f) Acesso a oportunidades de melhor remuneração',
  },
  { value: 'MATERNIDADE_PATERNIDADE', label: 'g) Priorização da maternidade/paternidade' },
  { value: 'DISTANCIA_LOCAL_APRENDIZAGEM', label: 'h) Distância casa- local de aprendizagem' },
  { value: 'NOVA_APREENSAO', label: 'i) Nova Apreensão' },
  { value: 'ABANDONO_SEM_EXPLICACAO', label: 'j) Abandono sem explicação' },
]

interface SchoolingLearningWorkProcessProps {
  control: any
  doNotHasEditPermission: boolean
  watch: (name: (value: any) => void) => any
}

const simNaoOptions = [
  {
    label: 'Sim',
    value: 'S',
  },
  {
    label: 'Não',
    value: 'N',
  },
]

const matriculadoOptions = [
  {
    label: 'Sim',
    value: 'S',
  },
  {
    label: 'Evadiu',
    value: 'E',
  },
  {
    label: 'Concluiu',
    value: 'C',
  },
]

const SchoolingLearningWorkProcess: React.FC<SchoolingLearningWorkProcessProps> = ({
  control,
  doNotHasEditPermission,
  watch,
}) => {
  const { setValue } = useFormContext()

  const [salaryAmountOptions, setSalaryAmountOptions] = useState<ItemOption[]>([])

  const [matriculadoValue, setMatriculadoValue] = useState<string | null>(null)
  const [isJovemAprendiz, setIsJovemAprendiz] = useState<boolean | null>(null)
  const [isApresentaAreaInteresse, setIsApresentaAreaInteresse] = useState<boolean | null>(null)
  const [isProfissionalizacao, setIsProfissionalizacao] = useState<boolean | null>(null)
  const [isEngressoTrabalhoInfantil, setIsEngressoTrabalhoInfantil] = useState<boolean | null>(null)

  const fillSalaryAmountOptions = useCallback(async (): Promise<void> => {
    await genericService
      .get('/faixa-renda')
      .then((res) => res && setSalaryAmountOptions(res.data))
      .catch((error) => console.log('error', error))
  }, [setSalaryAmountOptions])

  useEffect(() => {
    const subscription = watch((value) => {
      const parseStringToBoolean = (val: string) => {
        if (val === 'S') return true
        if (val === 'N') return false
        return null
      }

      setMatriculadoValue(value.meioAbertoAcompInfoEscolaAprendTrabalho?.matriculado)
      setIsJovemAprendiz(
        parseStringToBoolean(value.meioAbertoAcompInfoEscolaAprendTrabalho?.jovemAprendiz),
      )
      setIsProfissionalizacao(
        parseStringToBoolean(value.meioAbertoAcompInfoEscolaAprendTrabalho?.profissionalizacao),
      )
      setIsApresentaAreaInteresse(
        parseStringToBoolean(value.meioAbertoAcompInfoEscolaAprendTrabalho?.apresentaAreaInteresse),
      )
      setIsEngressoTrabalhoInfantil(
        parseStringToBoolean(
          value.meioAbertoAcompInfoEscolaAprendTrabalho?.engressoTrabalhoInfantil,
        ),
      )
    })
    return () => subscription.unsubscribe()
  }, [watch])

  useEffect(() => {
    if (matriculadoValue === 'E' || matriculadoValue === 'C') {
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.unidadeEnsino', null)
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.anoEscolar', null)
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.turnoEscolarizacao', null)
    }
  }, [matriculadoValue])

  useEffect(() => {
    if (!isJovemAprendiz) {
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.dataInicio', null)
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.empresa', null)
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.contato', null)
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.turnoJovemAprendiz', null)
    }
  }, [isJovemAprendiz])

  useEffect(() => {
    if (!isApresentaAreaInteresse) {
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.objetivoAreaInteresse', null)
    }
  }, [isApresentaAreaInteresse])

  useEffect(() => {
    if (!isProfissionalizacao) {
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.cursoProfissionalizante', null)
    }
  }, [isProfissionalizacao])

  useEffect(() => {
    if (!isEngressoTrabalhoInfantil) {
      setValue('meioAbertoAcompInfoEscolaAprendTrabalho.atividadeTrabalhoInfantil', null)
    }
  }, [isEngressoTrabalhoInfantil])

  useEffect(() => {
    fillSalaryAmountOptions()
  }, [fillSalaryAmountOptions])

  return (
    <Grid container item xs={12} spacing={2}>
      <Grid item md={12} xs={12}>
        <label>A - Escolarização</label>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={2} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.matriculado'
            label='Matriculado?'
            options={matriculadoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        {matriculadoValue === 'S' && (
          <>
            <Grid item md={4} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.unidadeEnsino'
                label='Unidade de Ensino'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <FormInputNumber
                name='meioAbertoAcompInfoEscolaAprendTrabalho.anoEscolar'
                label='Ano Escolar'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.turnoEscolarizacao'
                label='Turno'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
        {matriculadoValue === 'E' && (
          <>
            <Grid item md={4} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.anoParou'
                label='Em qual ano parou?'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
        {matriculadoValue === 'C' && (
          <>
            <Grid item md={4} xs={12}>
              <FormInputNumber
                name='meioAbertoAcompInfoEscolaAprendTrabalho.anoConclusaoEstudo'
                label='Ano de conclusão'
                maxLength={4}
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container item xs={12} spacing={2}>
        {matriculadoValue === 'S' && (
          <>
            <Grid item md={12} xs={12}>
              <FormControlRadio
                control={control}
                name='meioAbertoAcompInfoEscolaAprendTrabalho.frequencia'
                label='Frequente?'
                options={simNaoOptions}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
        <Grid item md={12} xs={12}>
          <FormInput
            name='meioAbertoAcompInfoEscolaAprendTrabalho.vinculoEscolar'
            label='Vínculo Escolar e Desenvolvimento'
            control={control}
            disabled={doNotHasEditPermission}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={2} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.jovemAprendiz'
            label='B - Inserido no Jovem Aprendiz?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        {isJovemAprendiz && (
          <>
            <Grid item md={2} xs={12}>
              <FormInputDatePicker
                name='meioAbertoAcompInfoEscolaAprendTrabalho.dataInicio'
                label='Data de Início'
                control={control}
                enableFuture={true}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.empresa'
                label='Empresa'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.contato'
                label='Contato'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.turnoJovemAprendiz'
                label='Turno'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
            <Grid container item xs={12} spacing={2}>
              <Grid item md={2} xs={12}>
                <FormControlRadio
                  control={control}
                  name='meioAbertoAcompInfoEscolaAprendTrabalho.apresentaAreaInteresse'
                  label='Apresenta Interesse?'
                  options={simNaoOptions}
                  disabled={doNotHasEditPermission}
                />
              </Grid>
              {isApresentaAreaInteresse && (
                <>
                  <Grid item md={10} xs={12}>
                    <FormInput
                      name='meioAbertoAcompInfoEscolaAprendTrabalho.objetivoAreaInteresse'
                      label='Qual o Objetivo?'
                      control={control}
                      disabled={doNotHasEditPermission}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </>
        )}
        {isJovemAprendiz != null && !isJovemAprendiz && (
          <>
            <Grid item md={5} xs={12}>
              <FormInputSelect
                control={control}
                name='meioAbertoAcompInfoEscolaAprendTrabalho.motivoNaoInserido'
                label='Motivo'
                options={motivosOptions}
              />
            </Grid>
            <Grid item md={5} xs={12}>
              <FormInputSelect
                control={control}
                name='meioAbertoAcompInfoEscolaAprendTrabalho.motivoNaoAdesao'
                label='Não Adesão'
                options={motivosNaoAdesaoOptions}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Label
              text={'Oportunidades de Jovem Aprendiz Encaminhadas:'}
              sx={{ fontSize: 14, color: 'text.primary' }}
            />
            <FormInput
              name='meioAbertoAcompInfoEscolaAprendTrabalho.oportunidadesJovemAprendizEcaminhadas'
              control={control}
              multiline
              minRows={4}
              disabled={doNotHasEditPermission}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <label>C - Trabalho</label>
        </Grid>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.trabalho'
            setValue={setValue}
            label='Trabalho'
            options={trabalhoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <FormInput
            name='meioAbertoAcompInfoEscolaAprendTrabalho.ativadades'
            label='Atividade'
            control={control}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <FormInput
            name='meioAbertoAcompInfoEscolaAprendTrabalho.local'
            label='Local'
            control={control}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <FormInput
            name='meioAbertoAcompInfoEscolaAprendTrabalho.turnoTrabalho'
            label='Turno'
            control={control}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <FormInputSelect
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.idValorRemuneracao'
            label='Valor da remuneração'
            options={salaryAmountOptions}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Label text={'Observações:'} sx={{ fontSize: 14, color: 'text.primary' }} />
            <FormInput
              name='meioAbertoAcompInfoEscolaAprendTrabalho.observacao'
              control={control}
              multiline
              minRows={4}
              disabled={doNotHasEditPermission}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.engressoTrabalhoInfantil'
            setValue={setValue}
            label='Adolescente ou Jovem egresso de trabalho infantil?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          {isEngressoTrabalhoInfantil && (
            <>
              <Box display={'flex'} flexDirection={'column'} gap={1}>
                <Label text={'Qual atividade?'} sx={{ fontSize: 14, color: 'text.primary' }} />
                <FormInput
                  name='meioAbertoAcompInfoEscolaAprendTrabalho.atividadeTrabalhoInfantil'
                  control={control}
                  multiline
                  minRows={3}
                  disabled={doNotHasEditPermission}
                />
              </Box>
            </>
          )}
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid item md={12} xs={12}>
          <label>D - Profissionalização</label>
        </Grid>
        <Grid item md={5} xs={12}>
          <FormControlRadio
            control={control}
            name='meioAbertoAcompInfoEscolaAprendTrabalho.profissionalizacao'
            label='Encaminhado a Curso Profissionalizante ou Projetos de Inclusão Produtivo?'
            options={simNaoOptions}
            disabled={doNotHasEditPermission}
          />
        </Grid>
        {isProfissionalizacao && (
          <>
            <Grid item md={7} xs={12}>
              <FormInput
                name='meioAbertoAcompInfoEscolaAprendTrabalho.cursoProfissionalizante'
                label='Se sim, qual?'
                control={control}
                disabled={doNotHasEditPermission}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default SchoolingLearningWorkProcess
